import { createSlice } from "@reduxjs/toolkit";
import { getSalesOrders } from "../reduxApi/salesOrdersReduxApi";

const salesOrdersSlice = createSlice({
    name: 'salesOrders',
    initialState: {
    status: 'idel',
    salesOrders: [],
    },
    reducers: {
        deletesalesOrdersAction: (state, action) => {
            action.payload.forEach((id) => {
                const index = state.salesOrders.findIndex((item) => item.salesOrders.ROWID === id);
                if (index !== -1) {
                    state.salesOrders.splice(index, 1);
                }
            });
        },     
        updatesalesOrdersAction: (state, action) => {
            console.log("action", action.payload)
            const index = state.salesOrders.findIndex((item) => item.salesOrders.ROWID === action.payload.ROWID)
            if (index != -1) {
                state.salesOrders.splice(index, 1, { salesOrders: action.payload })
            }
        },
        addsalesOrdersAction: (state, action) => {
            console.log("Adding salesOrders:", action.payload); 
            const temp = action.payload.formData;
            temp.ROWID = action.payload.ROWID;
            state.salesOrders.unshift({salesOrders:temp});
          }
    },
    extraReducers: (builder) => {
        builder.addCase(getSalesOrders.pending, (state, action) => {
            state.status = 'pending'
        })
            .addCase(getSalesOrders.fulfilled, (state, action) => {
                state.status = 'fulfilled'
                console.log("testing client Data",action.payload)                
                state.salesOrders = action.payload.data.salesOrdersData;
            })
    }
})
export const { deletesalesOrdersAction, updatesalesOrdersAction, addsalesOrdersAction } = salesOrdersSlice.actions
export default salesOrdersSlice.reducer